const userAgent = {
  'X-User-Agent':
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36 Edg/134.0.0.0'
}

const createRequestInterceptor = (httpClient) => {
  let { client } = httpClient

  client.interceptors.request.use(
    (config) => {
      const token = sessionStorage.getItem('mavAuth')
      config.headers = {
        'Accept-Language': localStorage.getItem('locale'),
        Authorization: token,
        ...userAgent
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )
}

const createRequestInterceptorBillma = (httpClient) => {
  let { client } = httpClient

  client.interceptors.request.use(
    (config) => {
      let token = sessionStorage.getItem('mavAuth')
      if (token) {
        token = token.replace('Token', 'Bearer')
      }
      config.headers = {
        'Accept-Language': localStorage.getItem('locale'),
        Authorization: token,
        ...userAgent
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )
}

const createResponseInterceptor = (httpClient, callback, router) => {
  let { client } = httpClient
  client.interceptors.response.use(
    async (request) => {
      if (request.status === 401) { // refresh token
        const token = callback()
        if (token) {
          sessionStorage.setItem('mavAuth', `Token ${token.token}`)
        }
      } else if (request.status === 403) { // expired token
        if (router) {
          router.replace({ name: 'timedout' })
        }
      }
      return request
    },
    (error) => {
      return Promise.reject(error)
    }
  )
}

export default {
  createRequestInterceptor,
  createResponseInterceptor,
  createRequestInterceptorBillma
}
